import { BoardParticipant, User } from 'types';

type GetMemberIdProps = {
  user: User;
  participants: BoardParticipant[];
};
const getUserMemberIds = (user: User) => [
  ...(user?.partners || []),
  ...(user?.partnerRepresentants || []),
];
const getBoardMembersId = (participants: BoardParticipant[]) =>
  participants.map((participant) => participant.member);

export const getMemberId = ({
  user,
  participants,
}: GetMemberIdProps): string => {
  if (!user) return '';
  const boardMembersId = getBoardMembersId(participants);
  const userMembers = getUserMemberIds(user);
  const memberId = userMembers.find((member) =>
    boardMembersId?.includes(member)
  );
  return memberId || '';
};
